import { CustomSvg, SvgIconDefaultProps } from '@libs/components';
import { useTheme } from 'styled-components';

const FaqGe: React.FC<SvgIconDefaultProps> = ({ className, testId, color }) => {
  const { colors } = useTheme();

  const iconColor = color ? color : colors.interactive.brandColor;
  return (
    <CustomSvg
      className={className}
      data-cy={testId}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M22 12C22 17.514 17.514 22 12 22C10.4085 22 8.831 21.615 7.4175 20.8855L3.587 21.955C3.4765 21.985 3.364 22 3.252 22C2.9245 22 2.604 21.871 2.3665 21.634C2.048 21.315 1.9255 20.848 2.0465 20.4145L3.116 16.586C2.385 15.171 2 13.5925 2 12C2 6.4855 6.486 2 12 2C17.514 2 22 6.4855 22 12ZM12.75 13.75C12.75 12.98 13.127 12.628 13.6485 12.14C14.2505 11.5775 15 10.8775 15 9.5C15 7.8455 13.6545 6.5 12 6.5C10.3455 6.5 9 7.8455 9 9.5C9 9.914 9.3355 10.25 9.75 10.25C10.1645 10.25 10.5 9.914 10.5 9.5C10.5 8.673 11.173 8 12 8C12.827 8 13.5 8.673 13.5 9.5C13.5 10.194 13.1995 10.507 12.6245 11.0445C12.012 11.6165 11.25 12.3285 11.25 13.75C11.25 14.164 11.5855 14.5 12 14.5C12.4145 14.5 12.75 14.164 12.75 13.75ZM12 15.5C11.4475 15.5 11 15.9475 11 16.5C11 17.0525 11.4475 17.5 12 17.5C12.5525 17.5 13 17.0525 13 16.5C13 15.9475 12.5525 15.5 12 15.5Z"
        fill={iconColor}
      />
    </CustomSvg>
  );
};

export default FaqGe;
